import { useEffect, useState } from "react";
import Table from "../components/Table";
import Modal from "../components/Modal";
import Form from "../components/Form";
const API_URL = process.env.REACT_APP_API_URL;
const ESTADO_INICIAL = {
    nombre: '', descripcion: '', sucursal_id: '', encargado_nombre: ''
};

export default function AreasScreen({ token }) {
    const [areas, setAreas] = useState([]);
    const [sucursales, setSucursales] = useState([]);
    const [showForm, setShowForm] = useState(false);
    const [loading, setLoading] = useState(true);
    const [areaForm, setAreaForm] = useState(ESTADO_INICIAL);
    const [modal, setModal] = useState({ visible: false, titulo: '', mensaje: '', tipo: 'info', onConfirm: null });
    const set = (campo) => (v) => setAreaForm(f => ({ ...f, [campo]: v }));
    const showModal = (tipo, titulo, mensaje, onConfirm = null) =>
        setModal({ visible: true, tipo, titulo, mensaje, onConfirm });

    const cargar = async () => {
        setLoading(true);
        try {
            const [resA, resS] = await Promise.all([
                fetch(`${API_URL}/areas`, { headers: { Authorization: `Bearer ${token}` } }),
                fetch(`${API_URL}/sucursales`, { headers: { Authorization: `Bearer ${token}` } }),
            ]);
            setAreas(await resA.json());
            setSucursales(await resS.json());
        } catch {
            showModal("error", "Error", "No se pudieron cargar los datos");
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => { cargar(); }, []);

    const abrirNuevo = () => {
        setAreaForm(ESTADO_INICIAL);
        setShowForm(true);
    };
    const cerrarForm = () => {
        setShowForm(false);
        setAreaForm(ESTADO_INICIAL);
    };
    const abrirEditar = (row) => {
        setAreaForm({ ...ESTADO_INICIAL, ...row, });
        setShowForm(true);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const handleGuardar = async (e) => {
        e.preventDefault();
        try {
            const esEdicion = !!areaForm.id;
            const res = await fetch(
                esEdicion ? `${API_URL}/areas/${areaForm.id}` : `${API_URL}/areas`,
                {
                    method: esEdicion ? 'PUT' : 'POST',
                    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
                    body: JSON.stringify(areaForm)
                }
            );
            const data = await res.json().catch(() => ({}));
            if (!res.ok) throw new Error(data.message);
            cerrarForm();
            cargar();
            showModal('success', 'Listo', esEdicion ? 'Área actualizada' : 'Área creada');
        } catch (err) {
            showModal('error', 'Error en catch handle guardar', err.message);
        }
    };

    const columnas = [
        { header: 'Nombre', accessor: 'nombre' },
        { header: 'Descripcion', accessor: 'descripcion' },
        { header: 'Sucursal', render: (row) => sucursales.find(s => s.id === row.sucursal_id)?.nombre ?? '—'},
        { header: 'Nombre del encargado', accessor: 'encargado_nombre' },
        { header: 'Acciones', render: (row) => (<button className="btn-edit" onClick={() => abrirEditar(row)}>Editar</button>) }
    ];
    // ── Config form ───────────────────────────────────────────────────────
    const campos = [
        { label: 'Nombre', value: areaForm.nombre, onChange: set('nombre'), required: true, placeholder: 'Nombre' },
        { label: 'Descripcion', value: areaForm.descripcion, onChange: set('descripcion'), placeholder: 'Descripcion' },
        { label: 'Sucursal', type: 'select', value: areaForm.sucursal_id, onChange: set('sucursal_id'), required: true, options: [{ value: '', label: '-- Selecciona --' }, ...sucursales.map(s => ({ value: s.id, label: s.nombre }))] },
        { label: 'Nombre del encargado', value: areaForm.encargado_nombre, onChange: set('encargado_nombre'), required: true, placeholder: 'Encargado' },
    ];
    if (loading) return <p>Cargando...</p>;
    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <h2>Áreas</h2>
                <button className="btn-secondary" onClick={showForm ? cerrarForm : abrirNuevo}>
                    {showForm ? 'Cancelar' : 'Nueva Area'}
                </button>
            </div>

            {showForm && (
                <Form campos={campos} onSubmit={handleGuardar} onCancel={cerrarForm}
                    submitLabel={areaForm.id ? 'Actualizar Area' : 'Crear Area'} />
            )}
            <Table columnas={columnas} datos={areas} />
            <Modal modal={modal} setModal={setModal} />
        </div>
    );
}